import { inject, Injectable } from '@angular/core';
import { AUTH_SERVICE, UserValue } from '@core-features/core';
import { UserBaseService } from '@core-features/user';
import { Observable, of } from 'rxjs';

/**
 * USER_SERVICE backed by the OIDC claims already held by AUTH_SERVICE.
 *
 * The widget reads role and partner-type facts but calls no identity API, so
 * the role helpers are inherited while the host service's dialog, HTTP client
 * and generated identity client are not.
 */
@Injectable()
export class PalchatUserService extends UserBaseService {
  private readonly _authService = inject(AUTH_SERVICE);

  readonly user$: Observable<UserValue> = this._authService.userInfo$;
  readonly $user = this._authService.$userInfo;

  uploadSignature(): Observable<void> {
    return of(undefined);
  }
}
